import {Divider} from "antd";
import {useContext, useEffect} from "react";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import AuthContext from "../utilis/contexts/AuthContext";
import AppContext from "../utilis/contexts/AppContext";

const UserRequests = () => {
    const authContext=useContext(AuthContext)
    const appContext=useContext(AppContext)
    useEffect(()=>{
        appContext.handleLoading(true)

        Api.post(Urls.getUserRequests, {
            Cellphone: authContext.user.cellphone,
        }, {
            headers: {
                "Authorization": authContext.Token.tokenType + " " + authContext.Token.accessToken
            }
        }).then((response: AxiosResponse) => {

            const {data}=response;
            const {Data}=data;
            const {requests}=Data;


        }).catch((e: AxiosError) => {

        }).finally(() => {
            appContext.handleLoading(false)
        })
    },[])
    return <>
        <Divider><h3 className="font-bold ">درخواست های من</h3></Divider>

    </>
}
export default UserRequests;